import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const quickLinks = ['Nosotros', 'Impacto', 'Equipo', 'Alianzas', 'Donar'];
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId.toLowerCase());
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="mp-footer bg-dark text-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-62" data-mp="3uftn9r2py01x">
      <div className="max-w-6xl mx-auto" data-id="element-63" data-mp="37ftv4932u2p">
        <div className="mp-footer-grid grid md:grid-cols-3 gap-8 mb-8" data-id="element-64" data-mp="36d2kv7umpm9">
          <div className="mp-footer-brand flex flex-col items-start text-left" data-id="element-65" data-mp="3le2icog05x94">
            <img src="https://cdn.magicpatterns.com/uploads/mCLKNbkU7trnwa9R6xuSbK/3.png" alt="Pancita Feliz Foundation" className="mp-footer-logo brightness-0 invert" style={{
            width: '200px',
            height: 'auto',
            objectFit: 'contain',
            display: 'block',
            marginBottom: '16px',
            marginLeft: 0,
            marginRight: 'auto'
          }} data-id="element-66" data-mp="3qc40n75ltsjj" />
            <p className="mp-footer-tagline text-sm text-gray-300" data-id="element-67" data-mp="3v9b11gq8w6ef">
              Descubre • Conecta • Evoluciona
            </p>
          </div>

          <div className="mp-footer-links" data-id="element-68" data-mp="830iphfda2zy">
            <h3 className="font-bold mb-4" data-id="element-69" data-mp="81pg3kxnr1af">Enlaces Rápidos</h3>
            <ul className="space-y-2" data-id="element-70" data-mp="34723g4s9vvk">
              {quickLinks.map(link => link === 'Donar' ? <li key={link} data-id="element-71" data-mp="ht3dnn61tr0x">
                    <Link to="/donar" className="text-gray-300 hover:text-primary transition-colors text-sm" data-id="element-72" data-mp="hs1x5369kcbt">
                      {link}
                    </Link>
                  </li> : <li key={link} data-id="element-73" data-mp="mt7s77necboi">
                    <button onClick={() => scrollToSection(link)} className="text-gray-300 hover:text-primary transition-colors text-sm" data-id="element-74" data-mp="mptrs4yamcjp">
                      {link}
                    </button>
                  </li>)}
            </ul>
          </div>

          <div className="mp-footer-social" data-id="element-75" data-mp="18k93pdwh6yah">
            <h3 className="font-bold mb-4" data-id="element-76" data-mp="18m3qkxrb50h7">Síguenos</h3>
            <div className="mp-footer-social-icons flex gap-4 mb-4" data-id="element-77" data-mp="1cmdywh2ko2z8">
              <a href="#" className="hover:text-primary transition-colors" aria-label="Facebook" data-id="element-78" data-mp="1hkfegs0shk5y">
                <FacebookIcon className="w-6 h-6" data-id="element-79" data-mp="1mkjvqk9iuix8" />
              </a>
              <a href="https://www.instagram.com/pancita_feliz?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" aria-label="Instagram" data-id="element-80" data-mp="1rhttqoaz82wo">
                <InstagramIcon className="w-6 h-6" data-id="element-81" data-mp="2agey3ug4ajcu" />
              </a>
            </div>
            <a href="mailto:info@pancitafelizfoundation.org" className="mp-footer-email" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: '12px',
            fontSize: '14px',
            color: 'rgba(255,255,255,0.75)',
            textDecoration: 'none'
          }} data-id="element-82" data-mp="25mu8apoogvoq">
              <MailIcon size={16} color="rgba(255,255,255,0.75)" data-id="element-83" data-mp="2pajsobuabtnx" />
              info@pancitafelizfoundation.org
            </a>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8 text-center" data-id="element-84" data-mp="2fdf30218dg2d">
          <p className="text-sm text-gray-300" data-id="element-85" data-mp="18ynw9hpff10f">
            © {new Date().getFullYear()} Pancita Feliz Foundation Inc. Todos
            los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}